import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs, jsx } from "react/jsx-runtime";
import { ExcursionInfoBox, ExcursionInfoBoxItem, ExcursionActivityLevelIcon, ShorexDrawerContent } from "@silversea-ssc/ui-components-react";
import { Trans, useLingui } from "@lingui/react";
import { s as shorexSplitNewFeature, f as formatShorexPrice } from "./format-shorex-price-Bhrx3kCA.js";
import { i as isPresent } from "./price-COKjAhbU.js";
const ContentExcursionInfoBox = _ref => {
  let {
    hideDurationAndCode,
    duration,
    activityLevel,
    accessibilityLevel,
    features
  } = _ref;
  return /* @__PURE__ */jsxs(ExcursionInfoBox, {
    children: [!hideDurationAndCode && !!duration && duration > 0 && /* @__PURE__ */jsx(ExcursionInfoBoxItem, {
      icon: "duration",
      label: /* @__PURE__ */jsx(Trans, _objectSpread({}, /*i18n*/
      {
        id: "lkz6PL",
        message: "Duration"
      })),
      value: /* @__PURE__ */jsx(Trans, _objectSpread({}, /*i18n*/
      {
        id: "TfR6jc",
        message: "{duration, plural, one {# hour} other {# hours}}",
        values: {
          duration
        }
      }))
    }), activityLevel && /* @__PURE__ */jsx(ExcursionInfoBoxItem, {
      icon: /* @__PURE__ */jsx(ExcursionActivityLevelIcon, {
        iconStep: activityLevel.iconStep || 0
      }),
      label: /* @__PURE__ */jsx(Trans, _objectSpread({}, /*i18n*/
      {
        id: "VWaI5s",
        message: "Activity Level"
      })),
      value: activityLevel.label,
      children: activityLevel.content
    }), accessibilityLevel && accessibilityLevel.icon && /* @__PURE__ */jsx(ExcursionInfoBoxItem, {
      icon: accessibilityLevel.icon,
      label: /* @__PURE__ */jsx(Trans, _objectSpread({}, /*i18n*/
      {
        id: "AnNF5e",
        message: "Accessibility"
      })),
      value: accessibilityLevel.label,
      children: accessibilityLevel.content
    }), features === null || features === void 0 ? void 0 : features.map((i, index) => /* @__PURE__ */jsx(ExcursionInfoBoxItem, {
      icon: i.icon,
      label: i.label || "",
      value: void 0,
      children: i.content
    }, index))]
  });
};
const SingleShorexDrawerContent = _ref2 => {
  let {
    cruiseType,
    hideDurationAndCode,
    shorex,
    microContent,
    isLoading,
    isUnbundling
  } = _ref2;
  const {
    _: _t,
    i18n
  } = useLingui();
  if (isLoading) return "Loading...";
  if (!shorex || !microContent) return null;
  const {
    activityLevels = [],
    accessibilityLevels = [],
    features = [],
    subcategories = []
  } = microContent;
  const activityLevelContent = activityLevels.find(l => (l === null || l === void 0 ? void 0 : l.iconStep) === shorex.activityLevel);
  const accessibilityLevelContent = accessibilityLevels.find(l => (l === null || l === void 0 ? void 0 : l.code) === shorex.accessibility);
  const subcategoriesContent = subcategories.find(l => (l === null || l === void 0 ? void 0 : l.code) === shorex.subcategory);
  const {
    featureNew,
    otherFeatures
  } = shorexSplitNewFeature(shorex.features, features);
  const formattedPrice = isUnbundling && shorex.price ? formatShorexPrice(shorex.price, shorex.priceType, i18n) : void 0;
  return /* @__PURE__ */jsx(ShorexDrawerContent, {
    code: "".concat(_t( /*i18n*/
    {
      id: "EWPtMO",
      message: "Code"
    }), ": ").concat(shorex.code),
    cruiseType,
    excursionInfoBox: /* @__PURE__ */jsx(ContentExcursionInfoBox, {
      accessibilityLevel: accessibilityLevelContent,
      activityLevel: activityLevelContent,
      features: otherFeatures.filter(isPresent),
      hideDurationAndCode,
      duration: shorex.duration
    }),
    image: shorex.image,
    title: shorex.name || "",
    priceFormattedAmount: isUnbundling ? formattedPrice : void 0,
    newTagLabel: featureNew === null || featureNew === void 0 ? void 0 : featureNew.label,
    mainCategory: isUnbundling ? shorex.category : void 0,
    subCategory: isUnbundling ? subcategoriesContent === null || subcategoriesContent === void 0 ? void 0 : subcategoriesContent.label : void 0,
    note: shorex.noteHtml ? /* @__PURE__ */jsx("div", {
      dangerouslySetInnerHTML: {
        __html: shorex.noteHtml
      }
    }) : void 0,
    children: shorex.descriptionHtml && /* @__PURE__ */jsx("div", {
      dangerouslySetInnerHTML: {
        __html: shorex.descriptionHtml
      }
    })
  });
};
export { SingleShorexDrawerContent as default };